module.exports = __webpack_public_path__ + "img/img25.eb2687c2.svg";